
import { Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
function Contact() {
    const { i18n } = useTranslation();
    return (
        <div className=" relative bg-white min-bh-screen pt-8 pb-24 px-4 md:px-16">
            <h1 className="text-3xl font-bold mb-6 text-center text-blue-700">Contact Us</h1>
            <div className="w-full h-64 mb-8">
                {/* <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3758.0100842640645!2d37
      .237246874199116!3d19.626866634450117!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15
      d754c5b7a49d5b%3A0x59a7d85670743a3a!2sFish%20market!5e0!3m2!1sen!2s!4v1762481755627!5m2!1sen!2s" 
        width="100%" height="100%" style={{border:0}} allowFullScreen="" loading="lazy">
        </iframe> */}
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d939.502521066016!2d37
        .239178064561465!3d19.626866634450128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.
        1!3m3!1m2!1s0x15d754c5b7a49d5b%3A0x59a7d85670743a3a!2sFish%20market!5e0!3m2!
        1sen!2s!4v1762482227353!5m2!1sen!2s" width="100%" height="100%" style={{ border: 0 }}
                    allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className="grid mb-grid-cols-2 gap-8 text-gray-700 text-lg">
                <div>
                    <p>
                        <span className="font-semibold"> Adress : Port Sudan The sea street</span>
                    </p>

                    <p>
                        <span className="font-semibold"> Email: doaa.ahmed@gmail.com</span>
                    </p>

                    <p>
                        <span className="font-semibold"> Phone: +249 129102102 </span>
                    </p>
                    <p>
                        <span className="font-semibold"> Work Ours: Satarda - thuresday  9 AM - 5 PM  </span>
                    </p>
                </div>
            </div>

            <a href="https://wa.me/+249129102102" target="_blank" rel="noopener noreferrer"
                className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg z-50">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                        d=" M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.57 1.38 5.06L2 22l4.9-1.38A9.94 9.94 0 0012 22c5.52 0 10-4.48 10-10s17.52 2 12 2z
        "/>
                </svg>
            </a>

        </div>
    )
}

export default Contact;